import { getFetchSite, postCreateSite, postFetchAllOrganisationBranches, postFetchAllSites } from "src/api/queries/order-portal-bff";
import { useNotification } from "src/composables/useNotification";
import mockResponse from "src/mocks/addresses.json";
import type { CreateSiteDTO, FetchSiteResponse, SiteFiltersDTO } from "src/api/models";
import type { PaginationParams } from "src/composables/ticket-entities/types";

export function useSiteService() {
  const { showSuccess, showError } = useNotification();

  async function fetchSite(siteId: string): Promise<FetchSiteResponse> {
    try {
      const response = await getFetchSite(siteId);
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchSites(filters?: SiteFiltersDTO, pagination?: PaginationParams) {
    try {
      const response = await postFetchAllSites(
        filters ?? {},
        {
          limit: pagination?.limit ?? 1000,
          page: pagination?.page ?? 1,
        }
      );

      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function fetchSitesByOrganisation(organisationId: string): Promise<FetchSiteResponse[]> {
    try {
      const response = await postFetchAllOrganisationBranches(organisationId);
      // API returns array directly, not wrapped in { data: [] }
      return Array.isArray(response) ? response : (response.data || []);
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function createSite(siteData: CreateSiteDTO): Promise<string> {
    try {
      const response = await postCreateSite(siteData);
      showSuccess({ message: 'Site created successfully' });
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  return {
    fetchSite,
    fetchSites,
    fetchSitesByOrganisation,
    createSite
  };
}
